import { FETCH_API } from '../../middleware';

export const AUTH_SELLER_EVENTS_REQUEST = 'AUTH_SELLER_EVENTS_REQUEST';
export const AUTH_SELLER_EVENTS_SUCCESS = 'AUTH_SELLER_EVENTS_SUCCESS';
export const AUTH_SELLER_EVENTS_FAILURE = 'AUTH_SELLER_EVENTS_FAILURE';

const fetchAuthorizedSellerEvents = ({accountId}) => {
  return {
    [FETCH_API]: {
      types: [AUTH_SELLER_EVENTS_REQUEST, AUTH_SELLER_EVENTS_SUCCESS, AUTH_SELLER_EVENTS_FAILURE],
      endpoint: `seller/${accountId}/events?apiKey=`,
      method: 'GET',
    },
  };
};

export const loadAuthorizedSellerEvents = (accountId) => {
  return dispatch => {
    return dispatch(fetchAuthorizedSellerEvents({accountId}));
  };
};

export const PUBLIC_EVENTS_REQUEST = 'PUBLIC_EVENTS_REQUEST'
export const PUBLIC_EVENTS_SUCCESS = 'PUBLIC_EVENTS_SUCCESS'
export const PUBLIC_EVENTS_FAILURE = 'PUBLIC_EVENTS_FAILURE'
const fetchPublicEvents = ({mpId}) => {
  return {
    [FETCH_API]: {
      types: [PUBLIC_EVENTS_REQUEST, PUBLIC_EVENTS_SUCCESS, PUBLIC_EVENTS_FAILURE],
      endpoint: `publicevents?mpId=${mpId}`,
      method: 'GET',
    }
  }
}

/** Redux action to fetch public events from MPAPI; uses a public endpoint (_no apiKey_)
 * @param {String<Number>} mpId marketplaceId
 * @returns {Promise<PublicEventsResponse>}
 */
export const loadPublicEvents = (mpId) => {
  return dispatch => {
    return dispatch(fetchPublicEvents({mpId}));
  }
}

export const PUBLIC_EVENT_LISTING_REQUEST = 'PUBLIC_EVENT_LISTING_REQUEST'
export const PUBLIC_EVENT_LISTING_SUCCESS = 'PUBLIC_EVENT_LISTING_SUCCESS'
export const PUBLIC_EVENT_LISTING_FAILURE = 'PUBLIC_EVENT_LISTING_FAILURE'
const fetchPublicEventListing = ({mpId, publicEventId}) => {
  return {
    [FETCH_API]: {
      types: [PUBLIC_EVENT_LISTING_REQUEST, PUBLIC_EVENT_LISTING_SUCCESS, PUBLIC_EVENT_LISTING_FAILURE],
      endpoint: `publicevents/${publicEventId}?mpId=${mpId}`,
      method: 'GET',
    }
  }
}

/** Redux action to fetch public event listing from MPAPI; uses a public endpoint (_no apiKey_)
 * @param {String<Number>|number} mpId marketplaceId
 * @param {String<Number>|number} publicEventId ID of public Event
 * @returns {Promise<PublicEventListingResponse>}
 */
export const loadPublicEventListing = (mpId, publicEventId) => {
  return dispatch => {
    return dispatch(fetchPublicEventListing({mpId, publicEventId}));
  }
}

/* Reset redux state for public event runlist */
export const RESET_PUBLIC_EVENT_LISTING = 'RESET_PUBLIC_EVENT_LISTING';
export const resetPublicEventListing = () => ({
  type: RESET_PUBLIC_EVENT_LISTING
});

/** Public Events response
 * @typedef {{
 *  "apiKey": string,
 *  "expiresOn": string,
 *  "publicEvents": PublicEventItem[],
 *  "wsStatus": "string",
 *  "wsMessage": "string"
 * }} PublicEventsResponse
 * 
 */

/** Public Event item
 * @typedef {{
 *  "eventId": number,
 *  "name": string,
 *  "startTime": string,
 *  "endTime": string,
 *  "itemCount": number
 *  }} PublicEventItem
 */

/** Public Runlist response
 * @typedef {{
 *  "apiKey": string,
 *  "expiresOn": string,
 *  "publicEvent": {
 *    "items": PublicEventListingItem[],
 *    "eventId": number,
 *    "name": string,
 *    "startTime": string,
 *    "endTime": string,
 *    "itemCount": number
 *  },
 *  "wsStatus": string,
 *  "wsMessage": string
 * }} PublicEventListingResponse
 */

/** Public Runlist item
 * @typedef {{
 *   "itemId": number,
 *   "vin": string,
 *   "year": number,
 *   "make": string,
 *   "model": string,
 *   "trim": string,
 *   "lotNumber": string,
 *   "mileage": number,
 *   "crGrade": string,
 *   "crLink": string
 * }} PublicEventListingItem
 */